import { render, staticRenderFns } from "./pv1.vue?vue&type=template&id=2936c53a&scoped=true&"
import script from "./pv1.vue?vue&type=script&lang=js&"
export * from "./pv1.vue?vue&type=script&lang=js&"
import style0 from "./pv1.vue?vue&type=style&index=0&id=2936c53a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936c53a",
  null
  
)

export default component.exports